import { render, staticRenderFns } from "./EmailModal.vue?vue&type=template&id=4d0a94d0&"
import script from "./EmailModal.vue?vue&type=script&lang=js&"
export * from "./EmailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports